import {
  Box,
  Button,
  Center,
  Flex,
  Image,
  Spinner,
  Text,
} from "@chakra-ui/react";
import React, { memo, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FormAdvanceRate from "../../../components/form/formAdvanceRate";
import iconPlus from "../../../assets/images/personnelCategories/plus.svg";
import { commissionCall } from "../../../api/commission";
import toast from "react-hot-toast";
import { formatNumber } from "../../../utils/utils";

const DetailStep2 = memo(({ isOpen, defaultValues }) => {
  const { reset } = useForm({
    defaultValues: defaultValues || {},
  });

  const [openItems, setOpenItems] = useState({});
  const [advanceRate, setAdvanceRate] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const fetchAdvance = async () => {
    try {
      const getTotalPriceData = await commissionCall.getByLocking(
        defaultValues.id
      );

      if (Array.isArray(getTotalPriceData) && getTotalPriceData.length > 0) {
        let lastPeriod = 1;
        const data = getTotalPriceData.map((item) => { 
          let commission = [];
          lastPeriod = item?.period;
          if (
            item?.commission &&
            Array.isArray(item?.commission) &&
            item?.commission.length > 0
          ) {
            commission = item?.commission.map((item) => {
              return ({
              interpretation: item?.interpretation,
              employee: item?.employeeObject?.fullName,
              workingDay: item?.workingDay,
              serviceFee: item?.serviceFee ? `${formatNumber(Number(item?.serviceFee))} VNĐ` : "0 VNĐ",
            })});
          }

          return {
            period: item?.period,
            calculateCommissionRate: item?.calculateCommissionRate,
            success: true,
            commission: commission,
            date: item?.dateStep,
          };
        });
        
        setOpenItems((prev) => ({
          ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {}), 
          [lastPeriod]: true,
        }));
        
        setAdvanceRate(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (defaultValues?.id) {
      fetchAdvance();
    }
  }, []);

  const handleChange = (period, field, value) => {
    setAdvanceRate(
      advanceRate.map((emp) =>
        emp.period === period ? { ...emp, [field]: value } : emp
      )
    );
  };

  const checkRate = () => {
    const totalRate = advanceRate.reduce(
      (total, item) => total + Number(item.calculateCommissionRate),
      0
    );

    if (totalRate > 100) {
      return false;
    }

    return true;
  };

  const onToggleContent = (period) => {
    setOpenItems((prev) => ({
      ...prev,
      [period]: !prev[period],
    }));
  };

  const onHandlePay = async (rate) => {
    if (defaultValues?.id) {
      const toastCreate = toast.loading("Đang tính toán ...");
      try {
        const data = {
          lockingId: defaultValues?.id,
          calculateCommissionRate: rate,
        };
        await commissionCall.create(data);
        fetchAdvance();
        toast.success("Tính toán thành công");
      } catch (error) {
        console.log({ error });
        toast.dismiss(toastCreate);
      }
      toast.dismiss(toastCreate);
    }
  };

  useEffect(() => {
    reset(defaultValues);
  }, [isOpen, reset, defaultValues]);

  const addAdvenceRate = () => {
    let foundlast = advanceRate.findLast((element) => element);
    
    setAdvanceRate([
      ...advanceRate,
      {
        period: foundlast?.period ? foundlast?.period + 1 : 1,
        calculateCommissionRate: 0,
        success: false,
        commission: [],
        date: null,
      },
    ]);

    if(foundlast){
      setOpenItems((prev) => ({
        ...prev,
        [foundlast?.period + 1]: true,
      }));
    }else{
      setOpenItems((prev) => ({
        1: true
      }));
    }
    
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={"0px"}>
        {advanceRate.slice().reverse().map((adv, index) => (
          <FormAdvanceRate
            period={adv.period}
            index={index}
            key={index}
            calculateCommissionRate={adv?.calculateCommissionRate}
            success={adv?.success}
            commission={adv?.commission}
            date={adv?.date}
            checkRate={checkRate}
            onHandlePay={onHandlePay}
            onChangeBonus={(e) => {
              handleChange(adv.period, "calculateCommissionRate", e);
            }}
            openItems={openItems[adv.period]}
            toggleContent={onToggleContent}
          />
        ))}

        {advanceRate.filter((adv) => adv.success === false).length <= 0 && (
          <Button
            w={"max-content"}
            mt={"16px"}
            display={"flex"}
            alignItems={"center"}
            p={"0px 12px"}
            gap={"10px"}
            borderRadius={"8px"}
            border={"1px solid var(--color-option-employee-hover)"}
            backgroundImage="var(--color-main)"
            bg={"var(--color-main)"}
            padding={"8px 12px"}
            h={"32px"}
            _hover={{
              filter: "brightness(95%)",
            }}
            onClick={() => addAdvenceRate()}
          >
            <Image src={iconPlus} />
            <Text
              fontSize={{ base: "13px" }}
              lineHeight={"16px"}
              fontWeight={600}
              color="var(--color-option-employee-hover)"
            >
              Thêm đợt thanh toán mới
            </Text>
          </Button>
        )}
      </Flex>
      {loading && (
        <Box
          pos={"fixed"}
          top={0}
          left={0}
          right={0}
          bottom={0}
          inset="0"
          bg="bg/80"
          zIndex={"1003"}
        >
          <Box
            pos={"absolute"}
            top={0}
            left={0}
            right={0}
            bottom={0}
            bg={"var(--color-header-employee)"}
            opacity={"0.15"}
            zIndex={"1004"}
          ></Box>
          <Center h="full" pos={"relative"} zIndex={"1005"}>
            <Spinner
              zIndex={"1005"}
              w={"50px"}
              h={"50px"}
              color="blue.500"
              style={{ animationDuration: "0.8s" }}
            />
          </Center>
        </Box>
      )}
    </>
  );
});

export default DetailStep2;
